import React from "react";

import ObjectOverride from "../ObjectOverride";
import Types from "constants/Types";


export default class ModuleLearnMore extends ObjectOverride {
	constructor(props) {
		super(props, Types.Locations_Modules._name);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		let object = this.state;
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name);
		}
	}

	render() {
		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col-md"}>
							<h4 className="section-title">This module does... yada yada yada</h4>
						</div>
					</div>
				</fieldset>
			</div>
		)
	};
}
